import { NotificationPopupComponent } from '@pure/notification-center';
import { Angulartics2Module } from 'angulartics2';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PlatformPageLayoutComponent } from '@pure/pure1-ui-platform-angular';
import { NotificationCenterModule } from '../notification-center/notification-center.module';

import { UIModule } from '../ui/ui.module';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { ExportModule } from '../export/export.module';
import { NpsSurveyModule } from '../nps-survey/nps-survey.module';
import { SupportModule } from '../support/support.module';

import {
    AvatarModule,
    BadgeModule,
    ButtonComponent,
    HiveTemplateDirective,
    MenuModule,
    RootDirective,
    SeparatorComponent,
    SvgDirective,
    TagComponent,
    TooltipModule,
} from '@pure/hive';
import { EmptyPageComponent } from './empty-page/empty-page.component';
import { AuthorizerModule } from '@pure/authz-authorizer';
import { PageRoutingModule } from './page-routing.module';
import { NavMenuIdPipe } from './pipes/nav-menu-id.pipe';
import { CopilotOnboardingModalComponent } from '../copilot/copilot-onboarding-modal/copilot-onboarding-modal.component';
import { FusionStatusMenuItemComponent } from '../fusion-fleet/fusion-status-menu-item/fusion-status-menu-item.component';

@NgModule({
    imports: [
        Angulartics2Module,
        AuthorizerModule,
        CommonModule,
        FormsModule,
        NgbModule,
        UIModule,
        ExportModule,
        NpsSurveyModule,
        SupportModule,
        TooltipModule,
        BadgeModule,
        NotificationCenterModule,
        SvgDirective,
        PageRoutingModule,
        RootDirective,
        NotificationPopupComponent,
        CopilotOnboardingModalComponent,
        SeparatorComponent,
        MenuModule,
        HiveTemplateDirective,
        AvatarModule,
        ButtonComponent,
        TagComponent,
        PlatformPageLayoutComponent,
        FusionStatusMenuItemComponent,
        NavMenuIdPipe,
        PageWrapperComponent,
        EmptyPageComponent,
    ],
})
export class PageModule {}
